import { Spin, StyledLoader } from "./styles";

export const Loader = () => (
  <StyledLoader>
    <Spin />
  </StyledLoader>
);
